import React from 'react'

const Layout = React.lazy(() => import('./Layout'))
const Login = React.lazy(() => import('./Login'))
const AuthFromCognito = React.lazy(() => import('./AuthFromCognito'))

export default {
  path: 'session',
  name: 'Session',
  component: Layout,
  childRoutes: [
    { path: 'login', name: 'Login', component: Login, isIndex: true },
    { path: 'register', name: 'Register', component: Login },
    { path: 'auth', name: 'Auth from cognito', component: AuthFromCognito },
  ],
};



// WEBPACK FOOTER //
// ./src/features/session/route.js